export const TEST_IDS = {
    // Public nav
    publicNav: {
        logo: "public-nav-logo",
        features: "public-nav-features",
        pricing: "public-nav-pricing",
        faq: "public-nav-faq",
        login: "public-nav-login",
        register: "public-nav-register",
        langToggle: "public-nav-lang-toggle",
    },
    landing: {
        heroCta: "landing-hero-cta",
        heroSecondary: "landing-hero-secondary",
        heroBadge: "landing-hero-badge",
        stat: (k) => `landing-stat-${k}`,
        featureCard: (k) => `landing-feature-${k}`,
        pricingTier: (k) => `landing-pricing-${k}`,
        pricingCta: (k) => `landing-pricing-cta-${k}`,
        faqItem: (k) => `landing-faq-${k}`,
        testimonial: (k) => `landing-testimonial-${k}`,
        footerLink: (k) => `landing-footer-${k}`,
    },
    auth: {
        emailInput: "auth-email",
        passwordInput: "auth-password",
        nameInput: "auth-name",
        submit: "auth-submit",
        googleBtn: "auth-google-btn",
        switchMode: "auth-switch-mode",
        error: "auth-error",
    },
    app: {
        sidebarCollapse: "app-sidebar-collapse",
        sidebarItem: (k) => `app-sidebar-${k}`,
        headerCredits: "app-header-credits",
        headerUser: "app-header-user",
        headerCmdk: "app-header-cmdk",
        headerLang: "app-header-lang",
        logout: "app-header-logout",
        cmdkPalette: "app-cmdk-palette",
        cmdkInput: "app-cmdk-input",
        cmdkItem: (k) => `app-cmdk-item-${k}`,
    },
    dashboard: {
        widget: (k) => `dashboard-widget-${k}`,
        aiInsight: "dashboard-ai-insight",
    },
};
